import styled from 'styled-components';

export const EventButtons = {
    Container: styled.div`
        padding: 0 10px;
        margin-top: 10px;

        button{
            width: auto;
            padding: 0 10px;
            background: var(--blueColor1);
            color: #fff;
            border: none;
        }
    `,
}

export const ListField = {
    Container: styled.div`
        margin-top: 10px;
        padding: 0 10px;

    `,
    Wrapper: styled.div`
        display: flex;
        flex-direction: column;
        gap: 10px;
    `,
    Item: styled.div`
        border: 1px solid #e0e0e0;
        padding: 10px;
        border-radius: 5px;

        .uuid{
            font-weight: 600;
            font-size: 14px;
        }

        button{
            width: auto;
            padding: 0 10px;
            background: var(--redColor2-light);
            color: var(--redColor2);
            border: none;
        }

        .status{
            margin-top: 10px;
            font-size: 12px;
            font-weight: 700;
            display: flex;
            gap: 10px;
            color: #a0a0a0;
            flex-wrap: wrap;
            .active{
                color:var(--purpleColor1);
            }
        }
    `,
}

export const AddModal = {
    BodyContainer: styled.div`
        padding: 10px;

        .notice{
            font-size: 14px;
            font-weight: 600;
            word-break: keep-all;
            margin-top: 10px;
        }

        .footerButtons{
            display: flex;
            gap: 10px;
            margin-top: 20px;

            button{
                background: #efefef;
                border: none;
            }

            button.confirm{
                background: var(--blueColor1);
                color: #fff;
                border: none;
            }
        }
    `,
}